define('gigaset_csp/components/compatibility/byproducts',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"gigaset/spinner",
	"shoptheme/components/tracking"
], function(
	$,
	_,
	Component,
	PubSubHub,
	BEM,
	Spinner
) {
	return Component.create({

		block: null,
		form: null,
		productOne: null,
		productTwo: null,
		productOneSelect: null,
		productOneImage: null,
		productTwoSelect: null,
		productTwoImage: null,
		productTypeWrapper: null,
		productOneTypeSelect: null,
		productOneTypeHidden: null,
		productOneType: null,
		productData: null,
		resultListContainer: null,
		resultListTemplate: null,
		xhrCache: null,

		$init: function() {
			this.block = BEM.block("csp-compatibility-byproducts");
			this.form = this.block.getElements("form");

			this.productOneSelect = this.block.getElements("product1");
			this.productTwoSelect = this.block.getElements("product2");

			this.productOneImage = this.block.getElements("product1-image");
			this.productTwoImage = this.block.getElements("product2-image");

			this.productOneImage.attr('data-default-src', this.productOneImage.attr('src'));

			this.productTypeWrapper = this.block.getElements("productTypeWrapper");
			this.productOneTypeSelect = this.block.getElements("product1-type");
			this.productOneTypeHidden = $('<input type="hidden" name="' + this.productOneTypeSelect.attr("name") + '" style="display: none;" />')
			this.productOneTypeHidden.insertAfter(this.productOneTypeSelect);
			this.productOneType = this.productOneTypeSelect.val();

			var productDataId = "productData_" + this.block.find("[data-products-id]").data("products-id");
			this.productData = productDataId in window ? window[productDataId] : {};

			this.resultListContainer = BEM.block("csp-compatibility-featureresult");
			this.resultListTemplate = _.template(this.block.find('[data-template="resultList"]').html());

			this.xhrCache = {};

			this.bindEvents();
			this.parseUrl();
			$(window).on('hashchange', $.proxy(this.parseUrl, this));
		},

		parseUrl: function() {
			var urlMatches = /#(.+)/.exec(document.location);
			var change = false;

			if (urlMatches) {
				this.productTwo = null; // Reset productTwo

				$.each(urlMatches[1].split("&"), $.proxy(function(i, fragment) {
					var parts = /(.+?)=([^&=]+)/.exec(fragment);

					if (!parts) return;

					if (parts[1] === "product1") {
						change = true;
						this.setProductOneInternal(parts[2]);
					} else if (parts[1] === "product1Type") {
						change = true;
						this.setProductOneTypeInternal(parts[2]);
					} else if (parts[1] === "product2") {
						change = true;
						this.setProductTwoInternal(parts[2]);
					}
				}, this));

				if (change) {
					this.onChange();
				}
			}
		},

		bindEvents: function() {
			this.productOneSelect.on("change", $.proxy(function(e, preventLoop) {
				if (this.productOneSelect.val() && this.productData[this.productOneSelect.val()].image) {
					this.productOneImage.attr("src", this.productData[this.productOneSelect.val()].image);
				} else {
					this.productOneImage.attr("src", this.productOneImage.attr('data-default-src'));
				}

				if (preventLoop) return;
				this.setProductOne(this.productOneSelect.val());
			}, this));

			this.productTwoSelect.on("change", $.proxy(function(e, preventLoop) {
				if (this.productTwoSelect.val() && this.productData[this.productTwoSelect.val()].image) {
					this.productTwoImage.attr("src", this.productData[this.productTwoSelect.val()].image);
				} else {
					this.productTwoImage.attr("src", this.productOneImage.attr('data-default-src'));
				}

				preventLoop|| this.setProductTwo(this.productTwoSelect.val());
			}, this));

			this.productOneTypeSelect.on("change", $.proxy(function(e, preventLoop) {
				var newValue = this.productOneTypeSelect.val();

				if (this.productOne && this.productOne.compatibleIds) {
					var productOneType = "basestation";
					var compatibleIds = this.productOne.compatibleIds;

					if ("basestations" in compatibleIds && compatibleIds.basestations.length) {
						if (newValue == "handset"
							|| (!("handsets" in compatibleIds) || !compatibleIds.handsets.length)
						) {
							productOneType = "handset";
						}
					}

					if (productOneType != newValue) {
						this.productOneTypeSelect.val(productOneType);
						return;
					}
				}

				preventLoop|| this.setProductOneType(newValue);
			}, this));
		},

		setProductOne: function(value) {
			this.setUrlHash({
				product1: value,
				product2: null,
				product1Type: null
			});
			return this;
		},

		setProductTwo: function(value) {
			this.setUrlHash({
				product2: value
			});
			return this;
		},

		setProductOneType: function(value) {
			this.setUrlHash({
				product1Type: value,
				product2: null
			});
			return this;
		},

		setProductOneTypeVisibility: function(prodTypeVisibility) {
			this.productOneTypeSelect.attr("disabled", prodTypeVisibility);
			var myElement = $('.b_csp-compatibility-byproducts__productTypeWrapper');
			myElement[prodTypeVisibility ? 'bemAddModifier' : 'bemRemoveModifier']("disabled");
		},

		setProductOneInternal: function(value) {
			this.productOneSelect.val(value).trigger("change", true);
			this.productOne = value in this.productData ? this.productData[value] : null;
			this.productOne.uid = value;

			var compatibleIds = this.productOne.compatibleIds;
			var enableSwitch = false;
			var switchType = false;

			if ("basestations" in compatibleIds && compatibleIds.basestations.length) {

				if (("handsets" in compatibleIds) && compatibleIds.handsets.length) {
					enableSwitch = true;
				} else {
					switchType = true;
					this.setProductOneTypeInternal("handset");
				}
			} else if (("handsets" in compatibleIds) && compatibleIds.handsets.length) {
				switchType = true;
				this.setProductOneTypeInternal("basestation");
			}

			if (!switchType) {
				this.setProductOneTypeInternal(this.productOneTypeSelect.val());
			}

			this.setProductOneTypeVisibility(!enableSwitch);

			return this;
		},

		setProductTwoInternal: function(value) {
			this.productTwoSelect.val(value).trigger("change", true);
			this.productTwo = value in this.productData ? this.productData[value] : null;
			this.productTwo.uid = value;
			return this;
		},

		setProductOneTypeInternal: function(value) {
			this.productOneTypeSelect.val(value).trigger("change", true);
			this.productOneTypeHidden.val(value);
			this.productOneType = value;

			this.fillProductTwoOptions();
			return this;
		},

		fillProductTwoOptions: function() {
			this.productTwoSelect.empty();

			var compatibleIds = this.productOne.compatibleIds.handsets;

			if (this.productOneType == "handset") {
				compatibleIds = this.productOne.compatibleIds.basestations;
			}

			_.forEach(compatibleIds, function(compatibleId) {
				var compatibleProduct = compatibleId in this.productData ? this.productData[compatibleId]: null;
				if (!compatibleProduct) return;

				var option = $('<option value="' + compatibleProduct.uid + '">' + compatibleProduct.name + '</option>')
				option.appendTo(this.productTwoSelect);
			}, this);

			this.productTwoSelect.val("").trigger("change", true);
		},

		onChange: function() {
			this.resultListContainer.html("");

			if (this.productOne && this.productTwo) {
				var cacheKey = [this.productOne.uid, this.productTwo.uid].sort().join("-");

				if (cacheKey in this.xhrCache) {
					this.resultListContainer.html(this.xhrCache[cacheKey]);
				} else {
					this.setLoading(true);

					$.ajax({
						type: this.form.attr("method") || "POST",
						url: this.form.attr("action"),
						data: this.form.serialize()
					}).then(_.bind(function(results) {
						var html = this.resultListTemplate({
							results: results
						});

						this.setLoading(false);
						this.xhrCache[cacheKey] = html;
						this.resultListContainer.html(html);
					}, this));
				}

				this.registerProductCombination();
			}
		},

		setLoading: function(status) {
			// this.resultListContainer[status ? "addClass" : "removeClass"]("loading");
			Spinner[status ? "add" : "remove"](this.block);
		},

		setUrlHash: function(values) {
			var hash = window.location.hash,
				originalHash = hash;

			_.forEach(values, function(value, key) {
				var regex = new RegExp(key + "=[^&=]+");

				if (_.isArray(value)) {
					value = value.join(",");
				}

				if (regex.match(hash)) {
					if (null === value) {
						hash = hash.replace(regex, "");
					} else {
						hash = hash.replace(regex, key + "=" + value);
					}
				} else {
					if (value !== null) {
						hash += hash.substr(0, 1) === "#" ? "&" : "#";
						hash += key + "=" + value;
					}
				}
			});

			hash = hash.replace(/&$/, ""); // strip trailing "&"

			if (hash !== originalHash) {
				window.location.hash = hash;
			}
		},

		registerProductCombination: function () {
			PubSubHub.emit("csp.compatibility.byproducts.view", {
				productOne: this.productOne,
				productTwo: this.productTwo
			});
		}
	});
});
